import axios from "axios"

const instance = axios.create({
  //baseURL: "/wp-admin/wp-ajax.php",
})

instance.options.emulateHTTP = true
instance.options.emulateJSON = true

export default instance
